import React, { FunctionComponent, useEffect, useState } from 'react';

import { css } from '@emotion/react';
import { ErrorMessage } from '@hookform/error-message';
import get from 'lodash/get';
import { FieldErrors, useController } from 'react-hook-form';

import { palette } from '@styles/theme';

interface Props {
  type?: 'text' | 'email' | 'number' | 'password' | 'submit';
  fieldName?: string;
  name: string;
  rules: any;
  errors: FieldErrors;
  isErrorText?: boolean;
  isErrorBorder?: boolean;
  errorTextAlign?: 'left' | 'center' | 'right';
  placeHolder?: string;
  maxLength?: number;
  readOnly?: boolean;
  width?: number;
  handleChange?: any;
  handleClick?: any;
  control: any;
  disabled?: boolean;
}

const Input: FunctionComponent<Props> = ({
  type = 'text',
  fieldName,
  name,
  rules,
  errors,
  isErrorText = true,
  isErrorBorder = false,
  errorTextAlign = 'right',
  placeHolder,
  maxLength = 100,
  readOnly,
  width,
  handleChange,
  handleClick,
  control,
  disabled,
}) => {
  const { field } = useController({
    control: control,
    name: name,
    rules: rules,
  });
  const [value, setValue] = useState(String(field.value));

  useEffect(() => {
    setValue(String(field?.value || ''));
  }, [field.value, setValue]);

  return (
    <div css={wrapper(width)}>
      <input
        css={container(
          width,
          isErrorBorder && Boolean(get(errors, name) || value.length > maxLength)
        )}
        type={type}
        value={value}
        autoComplete="off"
        placeholder={placeHolder || '값을 입력해 주세요.'}
        onChange={(e: any) => {
          if (handleChange) {
            handleChange(e, setValue, field.onChange, field.value);
          } else {
            field.onChange(e.target.value);
            setValue(e.target.value);
          }
        }}
        onClick={handleClick && handleClick}
        onBlur={field.onBlur}
        name={name}
        ref={field.ref}
        // maxLength={maxLength}
        readOnly={readOnly}
        disabled={disabled}
      />
      {isErrorText && get(errors, fieldName ? fieldName : name) && (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ message }) => (
            <p css={errorMessage(errorTextAlign)}>{message}</p>
          )}
        />
      )}
    </div>
  );
};

export default Input;

const wrapper = (width?: number) => css`
  display: flex;
  flex-direction: column;
  width: ${width ? `${width}px` : '100%'};
  padding: 6px 0;
`;

const container = (width?: number, isError?: boolean) => css`
  display: flex;
  box-sizing: border-box;
  width: ${width ? '100%' : 'calc(100% - 40px)'};
  height: 36px;
  border-radius: 5px;
  border: 1px solid ${isError ? palette.colorDanger : palette.gray3};
  padding: 0 10px;
  background-color: ${palette.white};
  position: relative;
  :focus {
    outline: none;
  }
  &[readOnly] {
    background-color: ${palette.gray1};
    color: ${palette.gray6};
  }
`;

const errorMessage = (textAlign: 'left' | 'center' | 'right') => css`
  color: ${palette.colorDanger};
  font-size: 12px;
  padding: 3px 5px;
  height: 22px;
  text-align: ${textAlign};
`;
